import { IOffer } from '../../../../types/offer';

export function isCommercialMultiAds(offer: IOffer): boolean {
  return Boolean(offer.areaParts && offer.areaParts.length > 0);
}
